<template>
    <div class="test-details-item">
        <div class="test-details-icon -center">
            <icon-test-comment/>
        </div>
        <div class="test-details-content">
            <div class="test-details-title">
                <span v-if="commentsToShow && commentsToShow.length">Коментарі <span>({{allCommentsCount}})</span></span>
                <span v-else>Ще немає жодного коментаря, будьте першим!</span>
            </div>

            <div v-if="store.user && store.user.id" class="test-comment">
                <div class="test-comment-avatar">
                    <img :src="store.user.media[0].original_url" alt="avatar">
                </div>
                <div class="test-comment-content">
                    <TestCommentEditor @addcomment="addComment" :error="commentError"/>
                </div>
            </div>
            <div v-else class="test-auth">
                <a href="/auth/facebook" class="link" data-event="login-facebook">Авторизуйтесь</a>, щоб залишити коментар
            </div>
            <div class="test-comments-container">
                <TestComment v-for="comment in commentsToShow" :key="comment.id" :user-data="userData"
                             :comment="comment" :comment-children="getCommentChildren(comment.id)" :test-id="testId"
                             @addreply="addComment" @updatelikes="updateLikes" @updatecomment="updateComment"
                             @removecomment="store.removeComment"/>
            </div>
            <button class="btn btn-outline toggle-child-tests"
                    v-if="commentsWithoutReplies && commentsWithoutReplies.length > 2"
                    @click="showAllComments = !showAllComments">
                <span v-if="showAllComments">Згорнути коментарі</span>
                <span v-else>Показати всі ({{ commentsWithoutReplies.length - 2 }})</span>
            </button>
        </div>
    </div>
</template>

<script>
import IconTestComment from '../../icons/IconTestComment.vue';
import TestComment from './TestComment.vue';
import TestCommentEditor from './TestCommentEditor.vue';
import {tourniquetStore} from '../../../store/store';
import {facebookComponent} from "../../../facebook-component";

export default {
    name: "TestComments",
    components: {TestCommentEditor, TestComment, IconTestComment},
    props: ['isLogin', 'testId', 'userData', 'removeCommentId'],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    data() {
        return {
            comments: [],
            showAllComments: false,
            commentError: false
        }
    },
    mounted() {
        this.getComments();
        facebookComponent.saveRedirect();
    },
    watch: {
        removeCommentId(newVal, oldVal) {
            if (oldVal !== null) {
                this.removeComment(oldVal)
            }
        }
    },
    computed: {
        allCommentsCount() {
            return this.comments.filter(item => !item.deleted).length;
        },
        commentsWithoutDeleted() {
            return this.comments.filter(item => item.deleted && item.has_child || !item.deleted );
        },
        commentsWithoutReplies() {
            return this.commentsWithoutDeleted.filter(item => !item.parent_id);
        },
        commentsToShow() {
            return this.showAllComments ? this.commentsWithoutDeleted.filter(item => !item.parent_id) : this.commentsWithoutDeleted.filter(item => !item.parent_id).slice(0,2)
        }
    },
    methods: {
        removeComment(id) {
            const commentIndex = this.comments.findIndex(item => item.id === id);
            this.comments.splice(commentIndex, 1);
        },
        updateLikes(id, data) {
            const commentIndex = this.comments.findIndex(item => item.id === id);
            this.comments[commentIndex].good_votes = data.vote_good;
            this.comments[commentIndex].bad_votes = data.vote_bad;
        },
        getCommentChildren(commentId) {
            return this.comments.filter(item => item.parent_id === commentId)
        },
        updateComment(id, data) {
            const commentIndex = this.comments.findIndex(item => item.id === id);
            this.comments.splice(commentIndex, 1, data)
        },
        getComments() {
            fetch(`/api/v1/tests/${this.testId}/comments`, {
                method: 'get',
                headers: {
                    'X-CSRF-TOKEN': this.store.csrfToken,
                },
            }).then(function(response) {
                return response.json();
            }).then((data) => {
                this.comments = data.data;
            });
        },
        addComment(text, replyId) {
            let data = new FormData();
            data.append('comment', text);
            data.append('commentable_id', parseInt(this.testId));
            data.append('parent_id', replyId !== undefined ? parseInt(replyId) : '');
            fetch('/comments', {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': this.store.csrfToken,
                },
                body: data
            }).then(response =>  response.json()).then((data) => {
                if (data.status === false && data.message) {
                    this.commentError = data.message

                } else {
                    this.commentError = false;

                        this.comments.unshift(data.data);


                    if (data.data.parent_id) {
                        const commentIndex = this.comments.findIndex(item => item.id === data.data.parent_id);
                        this.comments[commentIndex].has_child = true
                    }
                }
            });
        },
    }
}
</script>

<style lang="scss">
@import "../../../../../sass/front/helpers";
.test {
    &-auth {
         background: #F1F5FE;
         border-radius: 0.8rem;
         padding: 2rem;
         text-align: center;
         margin-bottom: 2rem;
     }

    &-comment {
        display: flex;
        gap: 0.8rem;
        padding-bottom: 2.8rem;

        &-content {
            flex: 1;
        }

        &-textarea {
            display: block;
            background: #F3F3F4;
            border-radius: 1.2rem;
            width: 100%;
            border: 1px solid transparent;
            font-family: 'Ukraine';
            resize: vertical;
            word-break: break-word;
            transition: all 0.3s;

            &.active {
                padding-bottom: 5.7rem;
            }

            &.is-edit {
                background: #fff;
            }

            &-container {
                position: relative;
            }

            &-btn {
                display: flex;
                gap: 6px;
                width: max-content;
                text-align: right;
                padding: 0 0.8rem;
                margin: -4.8rem 0 0 auto;

                .btn-small {
                    @include responsive-below($xs) {
                        padding: 1.2rem 1.4rem;
                    }
                }
            }

            &.focus {
                outline: none;
                border-color: #4578EB;
                background: #fff;
            }
        }

        &-avatar {
            width: 4rem;
            min-width: 4rem;
            height: 4rem;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            display: grid;
            place-items: center;
            background: #EEEEEE;

            @include responsive-below($sm) {
                width: 3.4rem;
                min-width: 3.4rem;
                height: 3.4rem;
            }

            &.no-avatar {
                border: solid 1px #94a3b8;
                display: grid;
                place-items: center;
            }

            & > img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
    }

    &-comments-container {
        margin-bottom: 2rem;

        @include responsive-below($md) {
            @include responsive-above($sm) {
                margin-right: -35rem;
            }
        }
    }
}

</style>
